/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1526
 */

module.exports = {
  wrapper: "CommonToast_wrapper__1vp1G"
}
